module.exports = __webpack_public_path__ + "img/TZS09378.a23130dc.jpeg";